import React from "react";
import "./Home.css";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Masonry from "react-masonry-css";
import { CirclePlus, CircleArrowRight, PlayCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ProtectedResourceItem = ({ children, navigateTo }) => {
	const { currentUser } = useAuth();
	const navigate = useNavigate();

	const handleClick = () => {
		if (!currentUser) {
			alert("Please log in to access resources");
			navigate("/login");
			return;
		}
		navigate(navigateTo);
	};

	return (
		<div onClick={handleClick} style={{ cursor: "pointer" }}>
			{children}
		</div>
	);
};

function Resources() {
	const navigate = useNavigate();

	return (
		<div className="main-container">
			<div className="video-background">
				<video
					autoPlay
					loop
					muted
					playsInline
					ref={(el) => {
						if (el) el.playbackRate = 0.75; // Adjust this value to control speed
					}}
				>
					<source src="/images/49a01d274a.mp4" type="video/mp4" />
				</video>
			</div>

			<section className="resources-section" id="resources">
				<Masonry
					breakpointCols={{
						default: 4,
						1100: 3,
						700: 2,
						500: 1,
					}}
					className="resources-masonry-grid"
					columnClassName="resources-masonry-grid_column"
				>
					<div
						className="resource-item logo"
						style={{ height: "100px", marginTop: "20px" }}
					>
						<div className="logo-circle">
							<img
								src="/logo192.png"
								alt="Sibling Kinect Logo"
								className="resources-img"
							/>
						</div>
						<h3>Sibling Kinect</h3>
					</div>
					<ProtectedResourceItem navigateTo="/mental-health-game">
						<div
							className="resource-item"
							style={{
								height: "200px",
								backgroundImage: "url('/images/mental-health-game.jpeg')",
								backgroundSize: "cover",
								backgroundPosition: "center",
							}}
						>
							<h3 className="resource-item-title">
								Mental Health Awareness Game
							</h3>
							<CirclePlus className="icon" style={{ color: "#d9d2c3" }} />
						</div>
					</ProtectedResourceItem>
					<ProtectedResourceItem navigateTo="/videos">
						<div className="resource-item" style={{ height: "200px" }}>
							<h3>Videos</h3>
							<span className="resource-item-subtitle-line"></span>
							<p>Stay Tuned</p>
							<PlayCircle className="icon" />
						</div>
					</ProtectedResourceItem>
					<ProtectedResourceItem navigateTo="/newsletter">
						<div className="resource-item" style={{ height: "120px" }}>
							<h3>Newsletter</h3>
							<span className="resource-item-subtitle-line"></span>
							<p>Stay Tuned</p>
							<CirclePlus className="icon" />
						</div>
					</ProtectedResourceItem>
					<ProtectedResourceItem navigateTo="/resources">
						<div
							className="resource-item"
							style={{
								height: "280px",
								backgroundImage: "url('/images/resources-resource.jpeg')",
								backgroundSize: "cover",
								backgroundPosition: "center",
							}}
						>
							<h3 className="resource-item-title">Resources</h3>
							<CircleArrowRight className="icon" style={{ color: "#d9d2c3" }} />
						</div>
					</ProtectedResourceItem>
					<ProtectedResourceItem navigateTo="/dictionary">
						<div
							className="resource-item"
							style={{
								height: "200px",
								backgroundImage: "url('/images/newpaper.jpeg')",
								backgroundSize: "cover",
								backgroundPosition: "center",
							}}
						>
							<h3 className="resource-item-title">Mental Health Dictionary</h3>
							<CirclePlus className="icon" />
						</div>
					</ProtectedResourceItem>
					<ProtectedResourceItem navigateTo="/blog">
						<div className="resource-item" style={{ height: "200px" }}>
							<h3>Blogs</h3>
							<span className="resource-item-subtitle-line"></span>
							<p>Stay Tuned</p>
							<CirclePlus className="icon" />
						</div>
					</ProtectedResourceItem>
					<div
						className="resource-item image"
						style={{
							height: "320px",
							backgroundImage: "url('/images/childrenImage.jpeg')",
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					></div>
				</Masonry>
			</section>

			<section className="kinect-section">
				<div
					style={{
						height: "300px",
						width: "80%",
						backgroundImage: "url('/images/services-home-bg.jpeg')",
						backgroundSize: "cover",
						backgroundPosition: "center",
						borderRadius: "10px",
					}}
				>
					<h1>Let’s bridge the gap and get kinected!</h1>
					<button className="cta-button" onClick={() => navigate("/contact")}>
						Contact Us
						<FontAwesomeIcon
							icon={faArrowRight}
							style={{ marginLeft: "10px" }}
						/>
					</button>
				</div>
			</section>

			<Footer />
		</div>
	);
}

export default Resources;
